import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppConfigService {
  constructor(private http: HttpClient) { }

  appBaseUrl: any;
  loggedUserDetails: {} = {};
  autzToken: string;
  idleTime: number;
  paxReqRadius;
  ivmsActualsUrl;
  ivmsTenantId: number;
  actualsTenantId: number;
  idleBufferTime: number;
  vehicleRadius: number;
  vehicleAverageSpeed: any;

  getAppConfigs() {
    return new Promise((resolve) => {
      this.http.get('./assets/data/config.json').subscribe(
        (response) => {
          this.setAppConfigs(response);
        }, (err) => {
        }, () => {
          resolve(true);
        }
      );
    });
  }

  setAppConfigs(response) {
    this.appBaseUrl = environment;
    this.idleTime = environment.idleTime;
    this.paxReqRadius = environment.paxRequestRadius;
    this.ivmsActualsUrl = environment.ivmsActualsUrl;
    this.ivmsTenantId = environment.ivmsTenantId;
    this.actualsTenantId = environment.actualsTenantId;
    this.idleBufferTime = environment.idleBufferTime;
    this.vehicleRadius = environment.vehicleRadius;
    this.vehicleAverageSpeed = {
      'lmv': response.lmvAverageSpeed,
      'bmv': response.bmvAverageSpeed
    }
  }

  setLoggedUserDetails(response) {
    this.loggedUserDetails = response;
  }

  getLoggedUserName() {
    return this.loggedUserDetails['USER_NAME'];
  }

  getRouteUrlConfigs() {
    return {
      // Transactions
      LOGSCHREQ: '/app/transaction/schedule/list',
      LOGREQ: '/app/transaction/mat-request/list',
      PLANLIST: '/app/transaction/plan/list',
      ALIL: '/app/transaction/inspection/list',
      CAMPAIGN: '/app/transaction/campaign/list',
      LOGTRIP: '',
      PASSALPLAN: '/app/transaction/passenger-allocation/summary',
      LOADINGNEW: '/app/transaction/tripsummary/list',
      JM: '/app/transaction/journeyplan/list',
      DRIVERSC: '/app/transaction/scorecard-regularization/list',
      PASSREQLOG: '/app/transaction/request-schedule/summary',
      RSLF: '/app/transaction/request/passenger',
      MATREQ: '/app/transaction/request/material',
      MANAGELOGSREQS: '',
      RMC: '',
      LP: '',
      INSP: '',
      GENERALPLANNING: '',
      LOADING: '',
      TMTX: '',
      ALID: '/app/transaction/driver-lp/summary',
      ADMINUSR: '/app/admin/user',
      ENTITY: '/app/admin/entity',
      ADMINUSRROLE: '/app/admin/user-ou-rolemapping',
      ROLEMST: '/app/admin/role-master',
      ADMINROLESCR: '/app/admin/rolescreen-mapping',
      ADMINROLETASK: '',
      EXCEP: '/app/transaction/exceptions/list',
      PASSQUICKRESPONSE: '/app/transaction/pax-quick-response/summary',
      SHUTTLE: '/app/master/shuttle/list',
      VISIBILITY: '/app/transaction/visibility/summary',
      FENCETX: '/app/transaction/fence/fence-masters',
      LOCTX: '/app/transaction/location/list',
      STMGMT: '/app/transaction/shuttle-management/summary',
      JNMB: '/app/transaction/journey-monitoring/summary',
      JRNYMTR: '/app/transaction/journey-monitoring-v2/summary',
      DRVRMTR: '/app/transaction/driver-monitoring/driver',
      APNTMGMT: '/app/transaction/applicant-master/summary',
      EMPDIR: '/app/transaction/employee/summary',
      ROUDIR: '/app/transaction/route/list',
      SHUTINDEX: '/app/transaction/shuttle-index',
      JNMBN: '/app/transaction/journey-monitoring/summary',
      DRIVERSCN: '/app/transaction/driver-scorecard/list',
      SHTR: '/app/transaction/shipment/summary',
      SLP: '/app/transaction/shipment/load-planning',
      DISCMAT: '/app/transaction/shipment/discrete-material-planning',
      CREW: '/app/transaction/crew/create',
      CAMRT: '/app/transaction/insp-campaign/summary',
      CAMRTDT: '/app/transaction/camp-report/summary',
      PARREQLOG: '/app/transaction/parcel-request/parcel',

      TSSHT:  '/app/transaction/snapshot-JM/summary',
      CAMDRV:'/app/transaction/driver-campaign/list',
      BSC: '/app/transaction/bcp-scorecard/list',
      MATVEHALLOC: '/app/transaction/vehicle-allocation/screen',
      SMALLPRCL: '/app/transaction/small-parcel/smlParcel',

      // Masters
      CAL: '/app/master/calendar/list',
      CHK: '/app/master/checklist/summary',
      CONS: '/app/master/constraint/summary',
      TERRITORY: '/app/master/territory/summary',
      EMP: '/app/master/employee/summary',
      LOC: '/app/master/location/list',
      NUM: '/app/master/numbering/numbering-master',
      SUPP: '/app/master/supplier/list',
      BUSSPARAM: '/app/master/business-parameters/params-master',
      CAR: '/app/master/carrier/summary',
      ROU: '/app/master/route/list',
      VEH: '/app/master/vehicle/summary',
      DRV: '/app/master/driver/summary',
      COST: '/app/master/costcenter/list',
      LPP: '/app/master/payload/payload-master',
      PLVTM: '/app/master/payload-vehicle/payload-vehicle-master',
      ITEM: '/app/master/item/summary',
      FENCE: '/app/master/fence/fence-masters',
      CVC: '',
      CUST: '',
      SYS: '/app/master/system-parameter/summary',
      VIO: '',
      SERITM: '',
      DIST: '',
      ALERT: '',
      REG: '',
      LANE: '',
      CHARGE: '',
      TARIFF: '/app/master/shuttle',
      TSVN: '',
      PFB: '/app/master/passenger-feedback/passenger-feedback',
      JMDRIV: '/app/master/jm-driver/list',
      INSPDRIV: '/app/master/insp-driver/list',
      DTMM:'/app/master/distance-matrix/list',
      VEHAV:'/app/master/vehicle-availability/list',
	    SMPBX:'/app/master/parcel_box_mapping/list',
      APPR:'/app/master/hazard/list',
      // reports
      RTR: '/app/report/journey',
      RCLNDR: '/app/report/resource-calendar',
      RRT: '/app/report/req-routing',
      JMM: '/app/report/multi-day-jp',
      REGRPT: '/app/report/regularization-report',
      BCPRPT: '/app/report/bcp-report',
      VEHAVRP: '/app/report/vehicle-availability-report',
      PDORPT: 'app/report/pdo-report',
      CREWLOGISTIC: 'app/report/crew-logistics-report',
      PASSENGERMANIFEST:'app/report/passenger-manifest-report',
      PHREPORT:'app/report/ph-report',
      SPLRFOOD: 'app/report/small-parcel-logistics-report-food',
      SPLROTHER: 'app/report/small-parcel-logistics-report-other',
      HZRDRPT: 'app/report/hazard-report',
      INTGRETRPT: 'app/report/integration-report',
      CCEINTR:'app/report/cce-intervened-report',
      PRFMRPT:'app/report/performance-report',
      INTRRPT:'app/report/interchange-report',
      DSCRPT:'app/report/driverScorecardReport',
      WTHR: 'app/report/weather-report',

    }
  }
}
